import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">吃瓜群众热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">来看看大家都在聊什么</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <article key={comment.id} className="bg-background-50 rounded-lg p-4 md:p-5 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800 truncate">{comment.name}</span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-100 text-accent-700 whitespace-nowrap">{comment.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 text-foreground-400 mt-auto pt-1">
                <i className="ri-heart-line text-sm"></i>
                <span className="text-xs">{comment.likes.toLocaleString()}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}